import { AccessNotice } from 'Order/types/location';

export const accessNoticeForDisplay = (accessNotice: AccessNotice) => {
  return accessNotice === AccessNotice.UpTo48Hours ? '0-48 hours' : 'Over 48 hours';
};
